import styled from 'styled-components'
import { tabletBreakpoint } from 'react-components'

export const ButtonContainer = styled.div`
    font-family: ${props => props.theme.typography.font.family.lato};
    font-size: ${props => props.theme.typography.font.size.medium};
    line-height: 1.18;
    text-align: ${({ theme }) => theme.style.textAlign.center};
    width: ${({ theme }) => theme.layout.fill};
    display: ${({ theme }) => theme.style.display.flex};
    flex-direction: ${({ theme }) => theme.style.flexDirection.row};
    justify-content: ${({ theme }) => theme.style.justifyContent.center};
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        max-width: 21.25rem;
    }
`
